export default __webpack_public_path__ + "static/media/folder-filled.c4d25e0c.svg";